import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiLogoGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-logo-generator',
			name: 'AI Logo Generator — Create Professional Logo Design Online | Lift',
			description:
				'Design your business logo with AI-powered logo maker in seconds. No watermark. Create professional logo design online — choose your style, add text, customize colors and fonts instantly. Try now!',
			url: 'https://liftapp.ai/ai-logo-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-logo-generator#product' },
				{ '@id': 'https://liftapp.ai/ai-logo-generator#howto' },
				{ '@id': 'https://liftapp.ai/ai-logo-generator#benefits' },
				{ '@id': 'https://liftapp.ai/ai-logo-generator#faq' },
				{ '@id': 'https://liftapp.ai/ai-logo-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-logo-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-logo-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-logo-generator#product',
			name: 'AI Logo Maker Online',
			description:
				"Create professional business logo designs with AI in seconds. Generate unique logo and design for your brand instantly. Try Lift's AI Logo Generator now!",
			url: 'https://liftapp.ai/ai-logo-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-logo-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Choose your business type and style',
					text: 'Select your industry and pick from various logo design styles — modern, minimalist, vintage, and more. Our AI logo generator adapts to your brand identity.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Describe your vision',
					text: 'Add your business name, tagline, and any specific requests. Tell our logo maker what makes your brand unique.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Add reference images',
					text: 'Upload reference photos for inspiration, and let our AI logo creator bring your vision to life.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download your design',
					text: 'Get your professional logo design instantly. Customize colors, fonts, and background, then download in high-resolution quality.',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-logo-generator#benefits',
			name: "Who can benefit from Lift's AI Logo Generator?",
			description:
				"Lift's AI Logo Generator is useful for startups, small businesses, freelancers, e-commerce sellers, and marketing teams who need professional branding without hiring a designer.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Startup founders & entrepreneurs — Use an AI logo generator to build a professional logo design from day one. Lift helps you create a business logo that reflects your brand idea instantly, without the cost or delay of hiring a designer.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Small business owners & solopreneurs — Design your logo online with a flexible logo maker that adapts as your business grows. Update colors, fonts, and styles to maintain consistent company logo design across all branding materials.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Freelancers & personal brands — Create a unique logo design with an AI logo creator that turns your name or concept into a polished visual identity. Perfect for building trust and standing out without design skills.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'E-commerce sellers & online businesses — Generate clean, recognizable branding using a logo generator designed for product packaging, stores, and ads. Strong logo and design help improve brand recall and conversion.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Marketing & growth teams — Speed up branding workflows with an AI logo maker that enables fast logo regeneration and testing. Instantly adapt logo design for campaigns, landing pages, and digital assets.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Logo Maker for Business Logo Design',
				description:
					'Example of how Lift AI Logo Generator creates professional business logos instantly.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-logo-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Logo Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Logo Generator is a premium online tool that instantly creates professional business logos with pixel-perfect precision — ideal for startups, small businesses, and entrepreneurs who need high-quality branding without hiring a designer.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Logo Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Simply choose your business type, enter your company name, select a style, and optionally add any specific preferences. Our AI automatically generates multiple logo design options in seconds — no graphic design experience needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I customize my logo design?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Absolutely! You can generate multiple variations by adjusting your text prompt, changing styles, or modifying background, logo color, and font. The AI logo maker gives you full creative control to explore different concepts until you find your perfect design.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-logo-generator#why-lift',
			name: "Why Lift's AI Logo Generator stands out",
			description:
				"Lift's AI Logo Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Professional AI Logo Maker',
				description:
					"Comparison of Lift's AI Logo Generator benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-logo-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-logo-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Logo Generator',
					item: 'https://liftapp.ai/ai-logo-generator',
				},
			],
		},
	],
};
